import { render, staticRenderFns } from "./MarketTemplatePage.vue?vue&type=template&id=e748ba2e&scoped=true"
import script from "./MarketTemplatePage.vue?vue&type=script&lang=js"
export * from "./MarketTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./MarketTemplatePage.vue?vue&type=style&index=0&id=e748ba2e&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e748ba2e",
  null
  
)

export default component.exports